import React, { useEffect, PropsWithChildren } from "react";
import { useContextSelector } from "use-context-selector";
import { BodyWrapper } from "../components/App/App.style";
import UserContext from "../components/proposals/contexts/userContext";
import { useConfig } from "../components/proposals/contexts/configContext";

type TrackPageProps = {
  pageName: string;
  anonymous?: boolean;
};

const Page: React.FC<PropsWithChildren<TrackPageProps>> = ({
  pageName,
  children,
  anonymous,
}) => {
  const { isThomasnet, origins } = useConfig();
  const loggedInUser = useContextSelector(UserContext, ctx => ctx.loggedInUser);
  const loggedInUserLoading = useContextSelector(
    UserContext,
    ctx => ctx.loggedInUserLoading
  );

  const preventRedirect = anonymous || window.location.search.includes("guest");

  useEffect(() => {
    if (!loggedInUserLoading) {
      window?.analytics?.page(pageName);
    }
  }, [loggedInUserLoading]);

  const redirect = () => {
    const path = encodeURIComponent(
      window.location.pathname + window.location.search
    );
    if (isThomasnet) {
      if ((window.location.search || "").includes("signin")) {
        console.error("potential infinite redirect detected... killing loop");
        return;
      }
      const next = `${
        origins.thomasnetHome
      }/account/login?url=${encodeURIComponent(window.location.href)}`;
      window.location.href = next;
    } else {
      window.location.href = `${origins.www}/login?domain=www&destination=${path}`;
    }
  };

  if (!preventRedirect && !loggedInUser && !loggedInUserLoading) {
    redirect();
    return <BodyWrapper />;
  }

  return <BodyWrapper>{children}</BodyWrapper>;
};

export default Page;
